<template>
  <div class="animated revealUp">
    <div class="section-title mb-4">{{ $t('movieanalytics') }}</div>
    <div class="white-wrapper">
      <div class="row">
        <!-- SELECT DROPDOWN -->
        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button class="btn-clearDate" v-if="getFromDate" @click="clearDate({ name: 'fromDate' })">✖</button>
              <Datepicker :monday-first="true"
                @selected="onMovieDropDownHandler({ event: $event, name: 'fromDate' })"
                :value="getFromDate"
                typeable
              ></Datepicker>
              <label :class="getFromDate ? 'active': ''">{{ $t("fromdate") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button class="btn-clearDate" v-if="getEndDate" @click="clearDate({ name: 'endDate' })">✖</button>
              <Datepicker :monday-first="true"
                @selected="onMovieDropDownHandler({ event: $event, name: 'endDate' })"
                :value="getEndDate"
                typeable
              ></Datepicker>
              <label :class="getEndDate ? 'active': ''">{{ $t("todate") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-8 col-xl-6 align-self-center align-self-lg-end align-self-xl-center mb-4">
          <div class="d-flex px-xl-3 align-items-center">
            <multiselect
              :options="MovieList"
              v-model="getSelectedMovies"
              @input="setSelectedMovies"
              :multiple="true"
              :searchable="true"
              :max="5"
              :showNoResults="true"
              :maxElements="true"
              label="movie"
              track-by="md_id"
              :placeholder="$tc('selectMovies')"
              name="selected_movies"
              id="selected_movies"
              @remove="toggleUnSelectMovie" 
              :showLabels="false"
            ></multiselect>
          </div>
        </div>


        <div class="col-lg-4 col-xl-3 align-self-center mb-4">
          <label class="text-muted small">{{ $tc('filter') }} {{ $tc('by') }}:</label>
          <div class="btn-group-sm">
            <button type="button" @click="OnSelectFilter('Day')" class="btn btn-primary">{{ $tc('day') }}</button>
            <button type="button" @click="OnSelectFilter('Week')" class="btn btn-primary">{{ $tc('week') }}</button>
            <button type="button" @click="OnSelectFilter('Month')" class="btn btn-primary">{{ $tc('month') }}</button>
          </div>
        </div>
        
        <div class="col-lg-12 col-xl-6 align-self-end mb-4 d-flex justify-content-center">
          <div>
            <button @click="onFetch" class="btn-blue">{{ $tc('fetch') }} {{ $tc('details') }}</button>
          </div>
        </div>
      </div>

      <div v-if="Moviechartloaded">
        <line-chart :chartdata="chartData" :options="getChartOptions" />
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import MovieService from "@/services/MovieService";
import { mapState, mapGetters, mapActions } from "vuex";
import LineChart from "@/components/ChartComponents/LineChart.js";

export default {
  components: { DatePicker, LineChart },
  data() {
    return {
      MovieList: [],
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.getMovieLabels,
        datasets: this.getMoviedatasets,
      };
    },
    ...mapGetters([
      "getFromDate",
      "getEndDate",
      "getChartOptions",
      "getMovieLabels",
      "getMoviedatasets",
      "getAllMovies",
      "Moviechartloaded",
    ]),
    getSelectedMovies: {
      get() {
        return this.$store.getters.getSelectedMovies;
      },
      set(value) {},
    },
  },
  beforeMount() {
    this.getMoviesList();
  },
  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;

    this.ClearDates(null);
    this.HideChart(false);
  },
  methods: {
    ...mapActions([
      "onMovieDropDownHandler",
      "onFetch",
      "OnSelectFilter",
      "setSelectedMovies",
      "clearDate",
      "ClearDates",
      "HideChart",
    ]),
    getMoviesList: function () {
      MovieService.GetActiveMoviesWithFormat()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.MovieList = data.Records;

            this.MovieList.push({
              md_id: 0,
              movie: "Deselect All",
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    toggleUnSelectMovie: function (movie) {
      this.$store.dispatch("removeUnSelectMovie", movie);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/MovieAnalytics.vue